import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { BuildingSearchService } from '../building-search.service';
import { BuildingHutsIdResponseModel } from '../models/buildingHutsId.response.model';

@Component({
  selector: 'app-advanced-search',
  templateUrl: './advanced-search.component.html'
})
export class AdvancedSearchComponent implements OnInit {
  @Input() isDisabled = false;
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() buildingSelected: EventEmitter<any> = new EventEmitter<any>();
  buildingSearchForm: FormGroup;

  buildingHutsId: number;
  buildingHutsIdResultsSubject: BehaviorSubject<BuildingHutsIdResponseModel[]> = new BehaviorSubject<BuildingHutsIdResponseModel[]>(null);
  buildingHutsIdResults$: Observable<BuildingHutsIdResponseModel[]> = this.buildingHutsIdResultsSubject.asObservable();
  selectedBuildingAddress: BuildingHutsIdResponseModel;
  selectedAddressFormSubject: BehaviorSubject<FormGroup> = new BehaviorSubject<FormGroup>(null);
  selectedAddressForm$: Observable<FormGroup> = this.selectedAddressFormSubject.asObservable();
  addressSearchBuildingDetails = true;
  constructor(
    private fb: FormBuilder,
    private buildingSearchService: BuildingSearchService
  ) {
    this.buildingSearchForm = this.fb.group({
      streetHouseNumber: new FormControl(''),
      streetDirectionPrefix: new FormControl(''),
      streetName: new FormControl(''),
      streetType: new FormControl(''),
      streetDirectionSuffix: new FormControl(''),
      county: new FormControl('')
    });
  }

  ngOnInit() {

  }

  search() {
    this.buildingSearchService.getBuildingDetailsForAdvancedSearch(this.buildingSearchForm.value).subscribe(response => {
      this.buildingHutsIdResultsSubject.next(response);
    });
  }

  addressSelected() {
    this.selectedAddressFormSubject.next(BuildingHutsIdResponseModel.generateForm(this.fb, this.selectedBuildingAddress, this.isDisabled));
    this.buildingSelected.emit(this.selectedBuildingAddress);
  }

  cancelAdvancedSearch() {
    this.cancel.emit(false);
  }

}
